/** EatWithSimer shipping checker. Preview theme only. */
(function () {
  'use strict';

  if (window.__EWS_SHIPPING_CHECKER_LOADED__) return;
  window.__EWS_SHIPPING_CHECKER_LOADED__ = true;

  const DATA = window.EWSShippingData;
  if (!DATA) {
    console.error('[EatWithSimer] Shipping checker data was not loaded.');
    return;
  }

  const RANGE_INDEX = buildRangeIndex(DATA.postcodeRanges || {});
  const ON_DEMAND = parseOnDemand(DATA.onDemandCompact || '');

  const STATE_NAMES = {
    ACT: 'Australian Capital Territory',
    NSW: 'New South Wales',
    NT: 'Northern Territory',
    QLD: 'Queensland',
    SA: 'South Australia',
    TAS: 'Tasmania',
    VIC: 'Victoria',
    WA: 'Western Australia'
  };

  function buildRangeIndex(source) {
    const index = {};
    Object.entries(source).forEach(([state, list]) => {
      index[state] = String(list)
        .split(',')
        .filter(Boolean)
        .map((token) => {
          const parts = token.split('-');
          const start = Number(parts[0]);
          const end = parts.length > 1 ? Number(parts[1]) : start;
          return [start, end];
        });
    });
    return index;
  }

  function parseOnDemand(source) {
    const result = {};
    if (!source) return result;

    source.split(';').forEach((group) => {
      if (!group) return;
      const colon = group.indexOf(':');
      if (colon < 0) return;

      const postcode = group.slice(0, colon);
      const rows = group.slice(colon + 1);

      result[postcode] = rows.split('^').map((row) => {
        const [suburb, km, cost] = row.split('~');
        return {
          suburb,
          km: Number(km),
          cost: Number(cost)
        };
      });
    });

    return result;
  }

  function statesForPostcode(postcode) {
    const numeric = Number(postcode);
    return Object.entries(RANGE_INDEX)
      .filter(([, ranges]) => ranges.some(([start, end]) => numeric >= start && numeric <= end))
      .map(([state]) => state);
  }

  function formatMoney(value) {
    return new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }

  function init(root) {
    if (!root || root.dataset.ewsShippingReady === 'true') return;

    const form = root.querySelector('[data-form]');
    const input = root.querySelector('[data-postcode]');
    const suburbWrap = root.querySelector('[data-suburb-wrap]');
    const suburbSelect = root.querySelector('[data-suburb]');
    const message = root.querySelector('[data-message]');
    const results = root.querySelector('[data-results]');
    const location = root.querySelector('[data-location]');
    const onDemandCard = root.querySelector('[data-ondemand]');
    const expressCard = root.querySelector('[data-express]');
    const onDemandPrice = root.querySelector('[data-ondemand-price]');
    const onDemandPricingNote = root.querySelector('[data-ondemand-pricing-note]');
    const onDemandDetail = root.querySelector('[data-ondemand-detail]');
    const onDemandCopy = root.querySelector('[data-ondemand-copy]');
    const surcharge = root.querySelector('[data-surcharge]');

    if (!form || !input || !suburbWrap || !suburbSelect || !message || !results ||
        !location || !onDemandCard || !expressCard || !onDemandPrice || !onDemandPricingNote ||
        !onDemandDetail || !onDemandCopy || !surcharge) {
      console.warn('[EatWithSimer] Shipping checker markup is incomplete.');
      return;
    }

    root.dataset.ewsShippingReady = 'true';

    function resetResults() {
      suburbWrap.hidden = true;
      suburbSelect.innerHTML = '<option value="">Choose your suburb</option>';
      suburbSelect.onchange = null;
      message.hidden = true;
      message.textContent = '';
      results.hidden = true;
      surcharge.hidden = true;
      onDemandPricingNote.hidden = false;
      onDemandCard.hidden = false;
      onDemandCard.removeAttribute('data-state');
      expressCard.style.gridColumn = '';
    }

    function revealResults() {
      results.hidden = false;
      if (window.matchMedia('(max-width: 749px)').matches) {
        window.requestAnimationFrame(() => {
          results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    }

    function showExpressOnly(postcode, states) {
      const stateName = states.length === 1 ? (STATE_NAMES[states[0]] || states[0]) : '';
      location.textContent = stateName ? `${stateName} ${postcode}` : `Postcode ${postcode}`;
      onDemandCard.hidden = true;
      expressCard.style.gridColumn = '1 / -1';
      surcharge.hidden = true;
      revealResults();
    }

    function showOnDemand(postcode, record) {
      location.textContent = `${record.suburb} NSW ${postcode}`;
      onDemandCard.hidden = false;
      expressCard.style.gridColumn = '';
      onDemandCard.removeAttribute('data-state');
      onDemandPricingNote.hidden = false;
      onDemandPrice.textContent = formatMoney(record.cost);
      onDemandDetail.textContent = `${record.km.toFixed(1)} km delivery distance`;
      onDemandCopy.textContent = 'Choose an available delivery date and time at checkout';
      surcharge.hidden = false;
      revealResults();
    }

    function requestSuburb(postcode, records) {
      records.forEach((record, index) => {
        const option = document.createElement('option');
        option.value = String(index);
        option.textContent = record.suburb;
        suburbSelect.appendChild(option);
      });

      suburbWrap.hidden = false;
      suburbSelect.focus();
      suburbSelect.onchange = () => {
        if (suburbSelect.value === '') {
          results.hidden = true;
          surcharge.hidden = true;
          return;
        }
        showOnDemand(postcode, records[Number(suburbSelect.value)]);
      };
    }

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const postcode = input.value.replace(/\D/g, '').slice(0, 4);
      input.value = postcode;
      resetResults();

      if (!/^\d{4}$/.test(postcode)) {
        message.textContent = 'Please enter a valid 4-digit Australian postcode.';
        message.hidden = false;
        input.focus();
        return;
      }

      const states = statesForPostcode(postcode);
      if (!states.length) {
        message.textContent = "We couldn't find this postcode in the Australian postcode list. Please check it and try again.";
        message.hidden = false;
        input.focus();
        return;
      }

      const records = ON_DEMAND[postcode];
      if (!records || !records.length) {
        showExpressOnly(postcode, states);
        return;
      }

      if (records.length === 1) {
        showOnDemand(postcode, records[0]);
        return;
      }

      requestSuburb(postcode, records);
    });

    input.addEventListener('input', () => {
      input.value = input.value.replace(/\D/g, '').slice(0, 4);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-ews-ship]').forEach(init);
  }

  const start = () => initAll(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target || document);
  });
})();
